<template>
  <label class="base-checkbox" :class="{ error: undefined !== errors }">
    <input
      v-model="modelValue"
      type="checkbox"
      :name="name"
      :value="value"
      @change="onChange"
    />
    <span class="base-checkbox__label">
      <slot />
    </span>
  </label>
</template>

<script setup>
import { FORM_INJECTION_KEY } from "~/nuxt_modules/common/constants/index.js";

const emits = defineEmits(["change"]);
const props = defineProps({
  value: { required: false },
  name: { type: String, required: true },
  color: {
    type: String,
    required: false,
    default: "var(--color-primary-base)",
  },
});

const modelValue = defineModel();

const { errors: formErrors, validateField } = inject(FORM_INJECTION_KEY);
const errors = computed(() => {
  return formErrors?.value[props.name];
});

function onChange(event) {
  emits("change", event.target.value);
  validateField(props.name);
}
</script>

<style lang="scss">
.filter-checkbox {
  width: 100%;
  padding: 8px 16px;

  @include on-hover {
    background-color: var(--color-sky-lighter);
  }

  &__compilation {
    display: flex;
  }

  &__title {
    @include flex-container(row, flex-start, flex-start);
    gap: 4px;

    @include font;
    word-break: break-word;

    @include bigMobile {
      @include font(14, 20);
    }
  }
}
</style>

<style scoped lang="scss">
.base-checkbox {
  position: relative;

  & input {
    height: 0;
    width: 0;

    position: absolute;
    left: 0;
    top: 50%;
    z-index: -1;

    opacity: 0;
    visibility: hidden;
  }

  & span::before {
    content: "";
    display: inline-block;

    @include fixedHW(24px);

    border: 1px solid var(--color-sky-base);
    border-radius: 4px;

    background-repeat: no-repeat;
    background-position: center;

    transition: border-color 0.2s ease;
  }

  &.error span::before {
    border-color: var(--color-red-dark);
  }

  & input:not(:checked) + span:hover::before {
    border-color: v-bind("color");
  }

  & input:checked + span::before {
    border-color: v-bind("color");
    background-color: v-bind("color");
    background-image: url("~~/assets/icons/check-icon.svg");
  }

  &.large .base-checkbox__label {
    @include font(16, 24);
  }

  &__label {
    @include flex-container(row, flex-start, center);
    gap: 16px;

    @include font(12, 16);

    user-select: none;
  }
}

:slotted(span) a {
  color: v-bind("color");
}
</style>
